import { Link } from "react-router-dom";
import { Check, Plus, Smartphone } from "lucide-react";
import { useCart } from "@/lib/cart";
import { ACC_TYPES, accTypeOf, usesModels, formatPrice, accessoriesFor } from "@/lib/store";
import { Eyebrow } from "./Reveal";

const MatchCard = ({ a, model }) => {
  const { add, has } = useCart();
  const forModel = usesModels(accTypeOf(a)) ? model : "";
  const added = has(a, forModel);
  const type = ACC_TYPES.find((t) => t.id === accTypeOf(a));
  return (
    <li data-testid={`match-item-${a.id}`} className="flex w-[220px] shrink-0 snap-start flex-col rounded-[22px] border border-white/10 bg-[#111113] p-2.5 sm:w-auto">
      <Link to={`/produto/${a.id}`} className="block aspect-square overflow-hidden rounded-2xl bg-zinc-900">
        {a.images?.[0]
          ? <img src={a.images[0]} alt={a.model} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 hover:scale-105" />
          : <Smartphone className="m-auto mt-16 h-8 w-8 text-zinc-500" />}
      </Link>
      <div className="flex flex-1 flex-col px-1.5 pb-1 pt-3">
        <p className="mono text-[11px] uppercase tracking-[0.18em] text-zinc-400">{type?.single}</p>
        <Link to={`/produto/${a.id}`} className="mt-1 line-clamp-2 text-sm font-semibold leading-snug text-white hover:underline">{a.model}</Link>
        <div className="mt-auto flex items-center justify-between gap-2 pt-3">
          <p className="font-display font-bold text-white">{formatPrice(a.price)}</p>
          <button data-testid={`match-add-${a.id}`} disabled={added} onClick={() => add(a, forModel)} aria-label={added ? "No carrinho" : `Adicionar ${a.model} ao carrinho`}
            className={`flex h-9 shrink-0 items-center gap-1 rounded-full px-3 text-xs font-semibold transition-colors ${added ? "bg-emerald-400/15 text-emerald-300" : "bg-white text-black hover:bg-zinc-200"}`}>
            {added ? <Check className="h-3.5 w-3.5" /> : <Plus className="h-3.5 w-3.5" />}{added ? "No carrinho" : "Adicionar"}
          </button>
        </div>
      </div>
    </li>
  );
};

export const MatchingAccessories = ({ product, all }) => {
  const list = accessoriesFor(all, product?.model, 8);
  if (!list.length) return null;
  return (
    <section data-testid="matching-accessories" className="mt-20 sm:mt-28">
      <Eyebrow>Combina com este iPhone</Eyebrow>
      <p className="mt-3 max-w-xl text-sm text-zinc-400 sm:text-base">Acessórios HPrime em estoque que servem no {product.model}.</p>
      <ul data-lenis-prevent className="no-scrollbar -mx-5 mt-8 flex snap-x snap-mandatory gap-3 overflow-x-auto px-5 sm:mx-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:overflow-visible sm:px-0 lg:grid-cols-4">
        {list.map((a) => <MatchCard key={a.id} a={a} model={product.model} />)}
      </ul>
    </section>
  );
};
